<template>
  <div>
    <b-modal :visible="modal" @hide="resetModalAndClose" v-b-modal="modalName">
      <template>
        <div slot="modal-title">
          {{ allocateTitle }}
        </div>
        <b-alert dismissible
                 @dismissed="clearScreen"
                 v-model="isApiCallComplete"
                 :variant="isSuccess ?('success') :('danger')">
          {{
            (isSuccess && isApiCallComplete) ? ($t('submitDomainSuccessMessage')) : ($t('submitDomainFailureMessage'))
          }}
        </b-alert>
      </template>
      <template>
        <table class="rdm-table">          
          <tbody>
            <tr v-for="(domainName, index) in tableData" :key="index">              
              <td width="80%">
                <span v-if="!editing[index]">{{ domainName }}</span>
                <input v-else v-model="tableData[index]" @blur="saveRow(index)"/>

              </td>
              <td>
                <b-button class="rdm-table-btn" @click="editRow(index)"><i style="color: #2071c5" class='fa fa-edit'></i></b-button>
                <b-button class="rdm-table-btn" @click="deleteRow(index)"><i style="color: #2071c5" class='fa fa-trash'></i></b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </template>
      <template>
        <div style="height:60px">
          <div style="display:inline-block; width:70%">
            <b-input class="modal-input"
                     :placeholder="enterDomainName"
                     v-model="domainNameInput"
                     :disabled="isHostTypeAny" />
            <b-button variant="primary" class="rdm-btn" @click="addDomain">{{ $t('addDomain') }}</b-button>
          </div>
          <div v-if="loading" class="loading-container">
            <i class="fa fa-spinner loading-animation fa-3x" />
          </div>
          <div style="float:right; margin-top:2%">
            <b-button variant="primary" class="rdm-btn" @click="submitRegisterDomains">{{ $t('submit') }}</b-button>
          </div>
        </div>
      </template>
      <div slot="modal-footer" />      
    </b-modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
  import SurveyModal from './SurveyModal'
  import Loading from './Loading'

  export default {
    name: 'RegisterDomainModal',
    components: {
      'loading': Loading,
      'typeahead': VueBootstrapTypeahead,
      'survey-modal': SurveyModal
    },
    props: {
      modal: { type: Boolean, required: true },
      closeModal: { type: Function, required: true },
      openModal: { type: Function, required: true },
      customHeader: { type: String, default: 'Add domains for strong network' }
    },
    data () {
      return {
        domainNameInput: '',
        editing: {},
        tableData: [],
        isSuccess: false,
        loading: false,
        isApiCallComplete: false
      }
    },
    mounted () {
      this.getDomainNameListForStrong()
    },
    created () {
      Vue.AppInsights.trackPageView('Register Domain page', '/registerDomain')
    },
    updated () {
    },
    computed: {
      allocateTitle () {
        return this.$t('addDomainsForStrongNetwork')
      },
      enterDomainName () {
        return this.$t('enterDomainName')
      }
    },
    methods: {
      getDomainNameListForStrong () {
        this.bottle.get(this.UrlBuilder.getDomainsListForStrong(this.$store.getters.person.customerId))
          .then(({ data: DomainNames }) => {
            this.tableData = DomainNames.DomainNames
          })
          .catch((error) => {
            this.loading = false
            this.hasApiCallFailed = true
            this.isApiCallDone = true
            this.loggly.log({
              errorMessage: 'Failed to get DomainDetails',
              errorObject: error,
              errorStack: error.stack
            })
          })
      },
      addDomain () {
        if (this.domainNameInput !== '') {
          this.tableData.push(this.domainNameInput)
          this.domainNameInput = ''
        }
      },
      submitRegisterDomains () {
        this.loading = true
        const DomainsRequest = {
          DomainNames: this.tableData
        }
        this.bottle.post(this.UrlBuilder.saveDomainsForStrong(this.$store.getters.person.customerId), { ...DomainsRequest })
          .then(({ data }) => {
            if (data) {
              this.isSuccess = true
            } else {
              this.isSuccess = false
            }
          })
          .catch((error) => {
            this.loading = false
            this.loggly.log({
              errorMessage: `Failed to save domain names`,
              errorObject: error,
              errorStack: error.stack
            })
          })
          .finally(() => {
            this.isApiCallComplete = true
            this.loading = false
          })
      },
      clearScreen () {
        this.isSuccess = false
        this.isApiCallComplete = false
      },
      resetModalAndClose () {
        this.closeModal()
        this.clearScreen()
        this.getDomainNameListForStrong()
      },
      editRow (index) {
        this.$set(this.editing, index, true)
      },
      saveRow (index) {
        this.$set(this.editing, index, false)
      },
      deleteRow (index) {
        if (index !== -1) {
          this.tableData.splice(index, 1)
          this.$delete(this.editing, index)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../styles/variables.scss';

  button:focus {
    box-shadow: none !important;
    border: none;
    outline: 0;
  }

  a {
    text-decoration: none !important;
  }

  .rdm-btn {
    display: inline-block;
    border-radius: 50px;
    padding-left: 20px;
    padding-right: 20px;
  }

  .rdm-table-btn {
    display: inline-block;
    border-radius: 10px;
    background-color: white !important;
    border-color: white !important;
  }

  .rdm-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 0.6rem;
    z-index: -2;
  }

  .rdm-table thead tr > th:first-child {
    width: 5%;
  }

  .rdm-table thead tr > th:nth-child(2) {
    width: 55%;
    border-right: 1px solid #dee2e6;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  .rdm-table thead tr > th:nth-child(3) {
    width: 20%;
  }

  .rdm-table thead tr > th:last-child {
    width: 10%;
    text-align: right;
  }

  .rdm-table thead,
  .rdm-table thead > tr {
    min-height: 50px;
  }

  .rdm-table th {
    background: $lightGray;
    border-color: $lightGray;
    font-weight: 400;
    padding: 15px 12px;
  }

  .rdm-table th:first-child,
  .rdm-table td:first-child {
    border-left: 1px solid #dee2e6;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  .rdm-table th:last-child,
  .rdm-table td:last-child {
    border-right: 1px solid #dee2e6;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  .rdm-table th,
  .rdm-table td {
    border-top: 1px solid #dee2e6;
    border-bottom: 1px solid #dee2e6;
  }

  .modal-input {
    display: inline-block;
    width: 48%;
    margin-top: 12px;
  }

  .loading-container {
    padding-top: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    display: inline-block;
    width: 10%;
    vertical-align: middle
  }

  .loading-animation {
    animation: loading-spin infinite 1s linear;
  }

  @keyframes loading-spin {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RegisterDomainModal.vue